var map = {
	"./a.svg": 1755,
	"./akesi.svg": 1799,
	"./ala.svg": 4510,
	"./alasa.svg": 5074,
	"./ale.svg": 8962,
	"./anpa.svg": 8926,
	"./ante.svg": 6566,
	"./anu.svg": 3048,
	"./awen.svg": 299,
	"./e.svg": 2727,
	"./en.svg": 8563,
	"./esun.svg": 2707,
	"./ijo.svg": 5550,
	"./ike.svg": 8787,
	"./ilo.svg": 6304,
	"./insa.svg": 2323,
	"./jaki.svg": 8353,
	"./jan.svg": 6677,
	"./jelo.svg": 3662,
	"./jo.svg": 5687,
	"./kala.svg": 3543,
	"./kalama.svg": 9937,
	"./kama.svg": 3568,
	"./kasi.svg": 3502,
	"./ken.svg": 8452,
	"./kepeken.svg": 6127,
	"./kili.svg": 2951,
	"./kiwen.svg": 6428,
	"./ko.svg": 852,
	"./kon.svg": 2890,
	"./kule.svg": 3943,
	"./kulupu.svg": 6002,
	"./kute.svg": 9935,
	"./la.svg": 4531,
	"./lape.svg": 8310,
	"./laso.svg": 6113,
	"./lawa.svg": 2155,
	"./len.svg": 155,
	"./lete.svg": 6862,
	"./li.svg": 7515,
	"./lili.svg": 4102,
	"./linja.svg": 3292,
	"./lipu.svg": 670,
	"./loje.svg": 8354,
	"./lon.svg": 1737,
	"./luka.svg": 7819,
	"./lukin.svg": 383,
	"./lupa.svg": 2214,
	"./ma.svg": 2284,
	"./mama.svg": 1634,
	"./mani.svg": 87,
	"./meli.svg": 9493,
	"./mi.svg": 5220,
	"./mije.svg": 439,
	"./moku.svg": 6362,
	"./moli.svg": 1975,
	"./monsi.svg": 9232,
	"./mu.svg": 1248,
	"./mun.svg": 7878,
	"./musi.svg": 4544,
	"./mute.svg": 489,
	"./nanpa.svg": 1968,
	"./nasa.svg": 5925,
	"./nasin.svg": 9649,
	"./nena.svg": 5606,
	"./ni.svg": 1213,
	"./nimi.svg": 4039,
	"./noka.svg": 2687,
	"./o.svg": 3821,
	"./olin.svg": 6614,
	"./ona.svg": 7842,
	"./open.svg": 6958,
	"./pakala.svg": 9750,
	"./pali.svg": 6058,
	"./palisa.svg": 4174,
	"./pan.svg": 7123,
	"./pana.svg": 4600,
	"./pi.svg": 319,
	"./pilin.svg": 4888,
	"./pimeja.svg": 2974,
	"./pini.svg": 1896,
	"./pipi.svg": 1070,
	"./poka.svg": 5257,
	"./poki.svg": 7521,
	"./pona.svg": 7214,
	"./pu.svg": 939,
	"./sama.svg": 5880,
	"./seli.svg": 7835,
	"./selo.svg": 7493,
	"./seme.svg": 9408,
	"./sewi.svg": 6550,
	"./sijelo.svg": 5714,
	"./sike.svg": 8690,
	"./sin.svg": 6184,
	"./sina.svg": 5801,
	"./sinpin.svg": 1093,
	"./sitelen.svg": 4384,
	"./sona.svg": 8911,
	"./soweli.svg": 6185,
	"./suli.svg": 7739,
	"./suno.svg": 6371,
	"./supa.svg": 7463,
	"./suwi.svg": 8982,
	"./tan.svg": 7399,
	"./taso.svg": 4729,
	"./tawa.svg": 5379,
	"./telo.svg": 5332,
	"./tenpo.svg": 124,
	"./toki.svg": 4349,
	"./tomo.svg": 1113,
	"./tu.svg": 727,
	"./unpa.svg": 3322,
	"./uta.svg": 9338,
	"./utala.svg": 1343,
	"./walo.svg": 3261,
	"./wan.svg": 8420,
	"./waso.svg": 2756,
	"./wawa.svg": 1510,
	"./weka.svg": 9966,
	"./wile.svg": 4463
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7036;